import React from "react";
import { getPath } from "../../../utils";
import BlankState from "../BlankState";
import styled from "styled-components";
import variables from "../../../constants/assets/variables";

const SAFE_WIDTH = 100;

export const defaultFieldValue = (row, key) => {
  const value = getPath(row, key, "");

  if (typeof value !== "number" && typeof value !== "string") {
    return JSON.stringify(value);
  }

  return value;
};

const Table = (props) => {
  const {
    fields,
    list,
    getFieldValue = defaultFieldValue,
    fontSize,
    rowClickable,
    onRowClick,
    dataTestid,
    isAdditionalRows = false,
    getAdditionalRows,
    wrapContents = false,
    blankStateComponent = <BlankState />,
  } = props;

  const handleRowClick = (item) => {
    if (rowClickable) {
      onRowClick(item);
    }
  };

  const getFieldWidth = (fields) => {
    //total table width
    const outerTable = document.getElementById("tableContainer");
    if (outerTable) {
      const oneFieldWidth = parseInt(outerTable.clientWidth) / fields.length;
      return oneFieldWidth;
    }
    //if table doesnt exist or not rendered yet, return safe width
    return SAFE_WIDTH;
  };

  return (
    <TableContainer
      data-testid={dataTestid}
      fontSize={fontSize}
      wrapContents={wrapContents}
      id="tableContainer"
      className="table-container h-full"
    >
      {getPath(list, "length", undefined) > 0 ? (
        <table border="1" className="list-table">
          <tbody>
            <tr className="tableHeadRow">
              {fields.map((field, index) => {
                return (
                  <th key={field.heading + index} className="header">
                    {field.heading}
                  </th>
                );
              })}
            </tr>
            {list.map((data, index) => (
              <tr
                onClick={() => handleRowClick(data)}
                className={`tableBodyRow ${rowClickable && "cursor-pointer"}`}
                key={data.id || index}
                data-testid={`row${index}`}
              >
                {fields.map((field, idx) => {
                  return (
                    <td
                      id={field.heading + index + idx}
                      data-testid={field.heading + index + idx}
                      key={field.heading + index + idx}
                      component="th"
                      className={
                        wrapContents
                          ? "bigVal"
                          : `${
                              parseInt(
                                (getFieldValue(data, field.key) + "").length
                              ) > getFieldWidth(fields) && "bigVal"
                            }`
                      }
                    >
                      {getFieldValue(data, field.key, index)}
                    </td>
                  );
                })}
              </tr>
            ))}
            {isAdditionalRows && getAdditionalRows()}
          </tbody>
        </table>
      ) : (
        <div>{blankStateComponent}</div>
      )}
    </TableContainer>
  );
};

const TableContainer = styled.section`
  background: ${variables.white};
  border: 0.5px solid ${variables.grey300};
  box-sizing: border-box;
  border-radius: 8px;
  height: 100%;
  overflow-y: scroll;

  .list-table {
    width: 100%;
    border-collapse: collapse;
    border: 0.5px solid ${variables.grey100};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : "0.875rem")};
    .tableBodyRow {
      font-weight: 500;
      color: ${variables.grey900};
    }
    th {
      line-height: 1rem;
      text-align: left;
      font-weight: normal;
      color: ${variables.grey600};
    }
    td,
    th {
      padding: 18px 12px;
    }
    .bigVal {
      word-break: break-word;
      white-space: pre-line;
    }
    .tableBodyRow:nth-child(even) {
      background-color: ${variables.grey100};
    }
  }
`;

export default React.memo(Table);
